import { render, staticRenderFns } from "./HC.vue?vue&type=template&id=4022f1dc&scoped=true"
import script from "./HC.vue?vue&type=script&lang=js"
export * from "./HC.vue?vue&type=script&lang=js"
import style0 from "./HC.vue?vue&type=style&index=0&id=4022f1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022f1dc",
  null
  
)

export default component.exports